module.exports = __webpack_public_path__ + "img/流体力学6_3.f1a59236.jpg";